// `v-click-outside="handler"`: call the handler when a click (or touch) lands outside the element.
// Replaces the v-click-outside package, which registers Vue 2 directive hooks (bind / update / unbind)
// and is therefore inert on Vue 3.
const EVENTS = typeof window !== 'undefined' && 'ontouchstart' in window ? ['touchstart'] : ['click'];
const LISTENERS = new WeakMap();

function attach(el, handler) {
  if (typeof handler !== 'function') return;

  const listener = (event) => {
    const path = event.composedPath ? event.composedPath() : null;
    const inside = path ? path.indexOf(el) >= 0 : el.contains(event.target);
    if (!inside) handler(event);
  };
  LISTENERS.set(el, listener);
  // the click that opened the element is still travelling up: start listening after it
  setTimeout(() => {
    if (LISTENERS.get(el) === listener) {
      EVENTS.forEach((event) => document.documentElement.addEventListener(event, listener, false));
    }
  }, 0);
}

function detach(el) {
  const listener = LISTENERS.get(el);
  if (!listener) return;
  EVENTS.forEach((event) => document.documentElement.removeEventListener(event, listener, false));
  LISTENERS.delete(el);
}

export default {
  beforeMount(el, binding) {
    attach(el, binding.value);
  },

  updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    detach(el);
    attach(el, binding.value);
  },

  unmounted(el) {
    detach(el);
  },
};
